module.exports = __webpack_public_path__ + "img/search.f920618f.svg";